import React, { useState, useEffect } from 'react';

import Grid from '@mui/material/Grid2';

import { 
  AbilityLimitation,
  DisableActionsFeature, 
  SpellLimitation,
  WeaponLimitation, 
} from "@dndModels";

import SelectStringBox from "@components/input/selects/SelectStringBox";
import WeaponLimitInput from "@dndComponents/limitations/WeaponLimitInput";
import AbilityLimitInput from "@dndComponents/limitations/AbilityLimitInput";
import SpellLimitInput from "@dndComponents/limitations/SpellLimitInput";

interface Props { 
  obj: DisableActionsFeature;
  onChange: (changed: DisableActionsFeature) => void;
  disabled?: boolean;
}

export default function DisableActionsFeatureInput({ 
  obj,
  onChange,
  disabled = false 
}: Props) {
  const [reloading, setReloading] = useState(false);
  const [myObj, setMyObj] = useState(obj.clone());
  
  useEffect(() => {
    if (reloading) {
      setReloading(false);
    }
  }, [reloading, setReloading]);

  // console.log(myObj);
  // console.log(obj);
  // const refresh_rule_helper = REFRESH_RULES.includes(obj.special_resource_refresh_rule) ? obj.special_resource_refresh_rule : "Special";
  return (
    <Grid container spacing={0} direction="row">
      <Grid
        size={{
          xs: 12
        }}>
        <SelectStringBox 
          name="Applies To"
          options={["Weapons","Abilities","Spells"]}
          values={myObj.apply_to}
          multiple
          onChange={(changed: ("Weapons" | "Abilities" | "Spells")[]) => {
            const new_obj = myObj;
            new_obj.apply_to = changed;
            setMyObj(new_obj);
            onChange(new_obj);
          }}
        />
      </Grid>
      { myObj.apply_to.includes("Weapons") && 
        <>
          <Grid
            className="header"
            size={{
              xs: 12
            }}>Weapon Limits</Grid>
          <Grid
            size={{
              xs: 12
            }}>
            <WeaponLimitInput
              obj={myObj.weapon_limit}
              disabled={disabled}
              onChange={(changed: WeaponLimitation) => {
                const new_obj = myObj;
                new_obj.weapon_limit = changed.clone();
                setMyObj(new_obj);
                onChange(new_obj);
              }}
            />
          </Grid>
        </>
      }
      { myObj.apply_to.includes("Abilities") && 
        <>
          <Grid
            className="header"
            size={{
              xs: 12
            }}>Ability Limits</Grid>
          <Grid
            size={{
              xs: 12
            }}>
            <AbilityLimitInput
              obj={myObj.ability_limit}
              disabled={disabled}
              onChange={(changed: AbilityLimitation) => {
                const new_obj = myObj;
                new_obj.ability_limit = changed.clone();
                setMyObj(new_obj);
                onChange(new_obj);
              }}
            />
          </Grid>
        </>
      }
      { myObj.apply_to.includes("Spells") && 
        <>
          <Grid
            className="header"
            size={{
              xs: 12
            }}>Spell Limits</Grid>
          <Grid
            size={{
              xs: 12
            }}>
            <SpellLimitInput
              obj={myObj.spell_limit}
              disabled={disabled}
              onChange={(changed: SpellLimitation) => {
                const new_obj = myObj;
                new_obj.spell_limit = changed.clone();
                setMyObj(new_obj);
                onChange(new_obj);
              }}
            />
          </Grid>
        </>
      }
    </Grid>
  );
}
